// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FileUpload.css */

.containerforupload {
    display: flex;
    justify-content: center;
    /* align-items: center; */
    height: 50vh;
    /* background-color: #f7f8fc; */
    
    padding-top: 6%;
    border-radius: 20px;
    background-color: white;
  }
  
  .upload-area {
    /* margin-top: 2%; */
   width: 400px;
   height: 250px;
    background-color: white;
    border: 2px dashed #00aaff;
    border-radius: 12px;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    cursor: pointer;

    transition: border-color 0.3s, transform 0.3s;
  }
  
  .upload-area:hover {
    border-color: #0077cc;
  }
  
  .instructions {
    text-align: center;
    color: #333;
  }
  `, "",{"version":3,"sources":["webpack://./src/views/panel/vraShifts/importVraShifts/ImportVraShifts.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;;IAE/B,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;GACrB,YAAY;GACZ,aAAa;IACZ,uBAAuB;IACvB,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;;IAEf,6CAA6C;EAC/C;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb","sourcesContent":["/* FileUpload.css */\n\n.containerforupload {\n    display: flex;\n    justify-content: center;\n    /* align-items: center; */\n    height: 50vh;\n    /* background-color: #f7f8fc; */\n    \n    padding-top: 6%;\n    border-radius: 20px;\n    background-color: white;\n  }\n  \n  .upload-area {\n    /* margin-top: 2%; */\n   width: 400px;\n   height: 250px;\n    background-color: white;\n    border: 2px dashed #00aaff;\n    border-radius: 12px;\n    display: flex;\n    /* justify-content: center; */\n    align-items: center;\n    cursor: pointer;\n\n    transition: border-color 0.3s, transform 0.3s;\n  }\n  \n  .upload-area:hover {\n    border-color: #0077cc;\n  }\n  \n  .instructions {\n    text-align: center;\n    color: #333;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
